const firebaseConfig = {
  apiKey: "AIzaSyABsQpwPqnog43OWcTqooxAdfL2KlH5_pE",
  authDomain: "volunteer-e59f0.firebaseapp.com",
  databaseURL: "https://volunteer-e59f0.firebaseio.com",
  projectId: "volunteer-e59f0",
  storageBucket: "volunteer-e59f0.appspot.com",
  messagingSenderId: "1042011728606",
  appId: "1:1042011728606:web:e1602385b0e5610ed5b04f"
};


  export default firebaseConfig